import React from "react";

export function usePrev<T>(value: T): T {
	const ref = React.useRef<T>(value);
	React.useEffect(() => {
		ref.current = value;
	}, [value]);
	return ref.current;
}
